// @flow
import React from 'react';

type Props = {
    asset: Object,
    openModal: Function,
};

const badgeSvg = (
    <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 30 30"
        style={{ enableBackground: 'new 0 0 30 30' }}
    >
        <path
            className="inplayer-lock"
            d="M20.9,14.7c0-4.6-2.7-8.4-5.9-8.4s-5.9,3.7-5.9,8.4H7.8v7.4c0,0.6,0.4,1,1,1h12.4c0.6,0,1-0.4,1-1v-7.4H20.9z M15,9.4c1.4,0,2.9,2.3,2.9,5.4h-5.8C12.1,11.7,13.7,9.4,15,9.4z"
        />
    </svg>
);

export const Preview = ({ asset, openModal, branding }: Object) => {
    let textColor =
        branding.preview_buttons_text_color &&
        branding.preview_buttons_text_color;
    let buttonColor =
        branding.preview_buttons_bg_color && branding.preview_buttons_bg_color;
    let noBox = branding.preview_top_border ? branding.preview_top_border : '';
    let noExplain = branding.inplayer_protected_label
        ? branding.inplayer_protected_label
        : '';

    let coverPhoto =
        'https://inplayer-paywall-v2.s3.amazonaws.com/images/ip-preview-premium.jpg';
    if (
        asset.metahash &&
        asset.metahash.paywall_cover_photo !==
            'https://inplayer-paywall-v2.s3.amazonaws.com/images/ip-preview-premium.jpg'
    ) {
        coverPhoto = asset.metahash.paywall_cover_photo;
    } else if (branding.paywall_cover_photo) {
        coverPhoto = branding.paywall_cover_photo;
    }

    return (
        <div className={'inplayer-preview-box ' + (noBox === '' && 'no-box')}>
            <div className="inplayer-imageholder">
                <img
                    src={coverPhoto}
                    onClick={e => {
                        e.preventDefault();
                        openModal(asset.id);
                    }}
                    className="inplayer-paywall"
                    style={{ cursor: 'pointer' }}
                />

                <div
                    className={
                        'inplayer-paywallexplain ' +
                        (noExplain === '' && 'no-explain')
                    }
                >
                    <div id="inplayer-whitelogo">
                        <strong>Protected by inplayer</strong>
                        <a href="https://inplayer.com">InPlayer Paywall</a>
                    </div>
                    <i>{badgeSvg}</i>
                    <span>Premium content</span>
                </div>
            </div>
            <div className="inplayer-itemdetails">
                <h3 className="inplayer-title">
                    {asset.metahash && asset.metahash.preview_title}
                </h3>
                <p
                    dangerouslySetInnerHTML={{
                        __html:
                            asset.metahash &&
                            asset.metahash.preview_description,
                    }}
                />
            </div>
            <div className="inplayer-buybutton">
                <button
                    className="inplayer-submit-button"
                    type="submit"
                    onClick={e => {
                        e.preventDefault();
                        openModal(asset.id);
                    }}
                    style={{
                        color: textColor,
                        background: buttonColor,
                    }}
                >
                    {asset.metahash && asset.metahash.preview_button_label}
                </button>
            </div>
            <div className="inplayer-preview-footer">
                <div className="inplayer-guest-footer">
                    <a
                        href="#login"
                        onClick={e => {
                            e.preventDefault();
                            openModal(asset.id);
                        }}
                    >
                        <span>Already have access? Login here.</span>
                        <br />
                        <span>
                            <span>InPlayer</span>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/ui/components/Preview.js